import { render, staticRenderFns } from "./FormPhotos.vue?vue&type=template&id=0cd818ba&"
import script from "./FormPhotos.vue?vue&type=script&lang=js&"
export * from "./FormPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports